import { cn } from "@/lib/utils";

type Variant = "create" | "montage" | "premium";

// Static, decorative brand character for hero areas only. CSS background (no <img>) so hidden breakpoints download nothing.
// Masks fade the render into the midnight-blue backdrop on the left and bottom; pointer-events none; text always wins (z-0).
// Desktop only: CREATE/MONTAGE from 1280px, PREMIUM (centered copy) from 1536px where the page margin can host it without touching text.
const SIZE: Record<Variant, string> = {
  create: "xl:block h-[400px] w-[820px]",
  montage: "xl:block h-[300px] w-[900px]",
  premium: "2xl:block h-[560px] w-[640px] !bg-left-top",  // keep the face (left of the render) when cover-cropping
};

// Horizontal fade tuned so the face sits in the fully opaque zone; the transparent zone is where long headlines may reach.
const FADE_X: Record<Variant, string> = {
  create: "transparent 0%, transparent 6%, rgba(0,0,0,.6) 18%, #000 30%, #000 90%, transparent 100%",
  montage: "transparent 0%, transparent 6%, rgba(0,0,0,.6) 18%, #000 30%, #000 90%, transparent 100%",
  premium: "transparent 0%, rgba(0,0,0,.6) 8%, #000 16%, #000 92%, transparent 100%",
};

export function HeroCharacter({ variant, className }: { variant: Variant; className?: string }) {
  const mask = `linear-gradient(to right, ${FADE_X[variant]}), linear-gradient(to bottom, #000 0%, #000 55%, transparent 100%)`;
  return (
    <div
      aria-hidden
      data-testid={`hero-character-${variant}`}
      className={cn("pointer-events-none absolute z-0 hidden select-none bg-cover bg-right-top bg-no-repeat", SIZE[variant], className)}
      style={{
        backgroundImage: `url(/brand/hero-${variant}.webp)`,
        WebkitMaskImage: mask,
        maskImage: mask,
        WebkitMaskComposite: "source-in",
        maskComposite: "intersect",
        opacity: 0.92,
      }}
    />
  );
}
